/** Igualdade do payload JSON: ordem de chaves nao importa; ordem de arrays importa. */
export function jsonStructurallyEqual(left: unknown, right: unknown): boolean {
  const canonical = (value: unknown) => JSON.stringify(value, (_key, item: unknown) => {
    if (item === null || typeof item !== "object" || Array.isArray(item)) return item;
    const record = item as Record<string, unknown>;
    return Object.fromEntries(Object.keys(record).sort().map((key) => [key, record[key]]));
  });
  return canonical(left) === canonical(right);
}
